import {applicationConfig} from '../applicationConfig';
import {openExternalUrl} from '../services/WindowOpener.service';

export const useFeedback = () => {
    const feedbackConfig = applicationConfig.feedback;

    const openFeedbackForm = () => {
        const url = feedbackConfig.url;
        if (!url) {
            return;
        }

        openExternalUrl(url);
    };
    return {isFeedbackEnabled: feedbackConfig.enable, openFeedbackForm};
};
